(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pm-review-carousel')) {
  customElements.define('pm-review-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this._events) return;
      this._events = new AbortController();
      const signal = this._events.signal;
      this.track = this.querySelector('[data-review-track]');
      this.cards = [...this.querySelectorAll('[data-review-card]')];
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.range = this.querySelector('[data-review-range]');
      this.dialog = this.querySelector('dialog');
      if (!this.track || !this.cards.length) return;
      this.previous.addEventListener('click', () => this.move(-1), {signal});
      this.next.addEventListener('click', () => this.move(1), {signal});
      this.track.addEventListener('scroll', () => {
        if (this._frame) return;
        this._frame = requestAnimationFrame(() => {this._frame = null; this.update();});
      }, {passive: true, signal});
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault(); this.track.scrollTo({left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.behavior()});
        }
      }, {signal});
      this.addEventListener('click', event => {
        const trigger = event.target.closest('[data-read-review]');
        if (!trigger || !this.contains(trigger)) return;
        const card = trigger.closest('[data-review-card]');
        this.dialog.querySelector('[data-dialog-quote]').innerHTML = card.querySelector('[data-review-text]').innerHTML;
        this.dialog.querySelector('[data-dialog-author]').innerHTML = card.querySelector('[data-review-author]').innerHTML;
        this.dialog.querySelectorAll('p').forEach(paragraph => paragraph.style.setProperty('display', 'block', 'important'));
        this._opener = trigger;
        this.dialog.showModal();
      }, {signal});
      this.dialog.querySelector('[data-close-review]').addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, {signal});
      this.dialog.addEventListener('close', () => this._opener?.focus({preventScroll: true}), {signal});
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-review-card]');
        if (card && this.contains(card)) this.track.scrollTo({left: card.offsetLeft - this.cards[0].offsetLeft, behavior: 'instant'});
      }, {signal});
      this._resize = new ResizeObserver(() => this.update());
      this._resize.observe(this.track);
      this.update();
      document.fonts?.ready.then(() => {if (this.isConnected) this.update();});
    }
    behavior() {return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';}
    columns() {return Number(getComputedStyle(this.track).getPropertyValue('--pm-review-columns')) || 1;}
    move(direction) {
      const step = this.cards[1] ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : this.track.clientWidth;
      const index = Math.round(this.track.scrollLeft / step);
      const target = Math.max(0, Math.min(this.cards.length - this.columns(), index + direction * this.columns()));
      this.track.scrollTo({left: target * step, behavior: this.behavior()});
    }
    update() {
      const step = this.cards[1] ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : this.track.clientWidth;
      const first = Math.round(this.track.scrollLeft / step);
      const end = Math.min(this.cards.length, first + this.columns());
      this.range.textContent = `${String(first + 1).padStart(2,'0')} — ${String(end).padStart(2,'0')} / ${String(this.cards.length).padStart(2,'0')}`;
      this.previous.disabled = this.track.scrollLeft < 2;
      this.next.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
    disconnectedCallback() {
      this._events?.abort(); this._events = null; this._resize?.disconnect(); cancelAnimationFrame(this._frame); this._frame = null;
      if (this.dialog?.open) this.dialog.close();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-kit-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();
    const format = (template, values) => Object.entries(values).reduce((text, [key, value]) => text.replaceAll(`[${key}]`, String(value)), template);
    function initialize(root) {
      if (instances.has(root)) return;
      let data;
      try { data = JSON.parse(root.querySelector('[data-kit-data]').textContent); } catch { return; }
      const products = new Map(data.products.map(product => [product.handle, product]));
      const families = new Map(data.families.map(family => [family.id, family]));
      const gallery = root.querySelector('[data-gallery]');
      const baseCards = Array.from(gallery.children);
      if (!baseCards.length) return;
      baseCards.forEach(card => { card.dataset.kitDenomination = 'mixed'; });
      // Keep each product as its own card so All actually exposes all 24 kits.
      ['one', 'twenty', 'hundred'].forEach(value => {
        baseCards.forEach(base => {
          if (!products.has(families.get(base.dataset.kitId)?.options[value])) return;
          const card = base.cloneNode(true);
          card.dataset.kitDenomination = value;
          card.removeAttribute('data-shopify-editor-block');
          gallery.append(card);
        });
      });
      const cards = Array.from(gallery.children);
      const controller = new AbortController();
      const signal = controller.signal;
      const previous = root.querySelector('[data-direction="-1"]');
      const next = root.querySelector('[data-direction="1"]');
      const counter = root.querySelector('[data-counter]');
      const jumps = Array.from(root.querySelectorAll('[data-jump]'));
      const choices = Array.from(root.querySelectorAll('[data-denomination]'));
      const stackChoices = Array.from(root.querySelectorAll('[data-stack-count]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let denomination = 'all';
      let stackCount = 'all';
      let index = 0;
      let scheduled = false;
      const selectedProduct = (card, value = card.dataset.kitDenomination) => products.get(families.get(card.dataset.kitId)?.options[value]);
      const matchesStack = product => Boolean(product) && (stackCount === 'all' || product.stacks === Number(stackCount));
      const visibleCards = () => cards.filter(card => !card.hidden);
      const visibleCount = () => Math.min(visibleCards().length, parseInt(getComputedStyle(root).getPropertyValue('--pmks-visible'), 10) || 1);
      const step = () => {
        const active = visibleCards();
        return active.length > 1 ? active[1].offsetLeft - active[0].offsetLeft : active[0]?.getBoundingClientRect().width || 1;
      };
      function update() {
        scheduled = false;
        const active = visibleCards();
        const visible = visibleCount();
        index = Math.max(0, Math.min(active.length - visible, Math.round(gallery.scrollLeft / step())));
        previous.disabled = index === 0;
        next.disabled = index >= active.length - visible;
        counter.textContent = format(visible === 1 ? data.labels.single_counter : data.labels.counter, { first: active.length ? index + 1 : 0, last: Math.min(active.length, index + visible), total: active.length });
        jumps.forEach((button, position) => {
          const familyId = baseCards[position].dataset.kitId;
          button.hidden = !active.some(card => card.dataset.kitId === familyId);
          button.setAttribute('aria-pressed', String(active.slice(index, index + visible).some(card => card.dataset.kitId === familyId)));
        });
      }
      function move(position) {
        const target = Math.max(0, Math.min(visibleCards().length - visibleCount(), position));
        gallery.scrollTo({ left: target * step(), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      }
      function renderSelection() {
        const matchingProducts = [];
        cards.forEach((card, position) => {
          const product = selectedProduct(card);
          card.hidden = (denomination !== 'all' && card.dataset.kitDenomination !== denomination) || !matchesStack(product);
          if (!card.hidden) matchingProducts.push(product);
          const image = card.querySelector('img');
          const availability = card.querySelector('[data-availability]');
          card.querySelector('[data-denomination-label]').textContent = data.labels.descriptions[card.dataset.kitDenomination];
          availability.hidden = Boolean(product?.available);
          availability.textContent = product ? data.labels.sold_out : data.labels.unavailable;
          card.querySelector('[data-price]').textContent = product ? product.price : '';
          if (image) {
            image.hidden = !product?.image;
            if (product?.image) {
              image.srcset = product.srcset || '';
              image.src = product.image;
              image.alt = product.alt || product.title;
            }
          }
          card.querySelectorAll('[data-product-link]').forEach(link => {
            if (product) {
              link.href = product.url;
              link.setAttribute('aria-label', product.title);
              link.removeAttribute('aria-disabled');
              link.hidden = false;
            } else {
              link.removeAttribute('href');
              link.setAttribute('aria-disabled', 'true');
              if (!link.classList.contains('pmks__photo')) link.hidden = true;
            }
          });
        });
        choices.forEach(button => {
          button.disabled = !cards.some(card => (button.dataset.denomination === 'all' || card.dataset.kitDenomination === button.dataset.denomination) && matchesStack(selectedProduct(card)));
          button.setAttribute('aria-pressed', String(button.dataset.denomination === denomination));
        });
        stackChoices.forEach(button => {
          const value = button.dataset.stackCount;
          button.disabled = !cards.some(card => {
            const product = selectedProduct(card);
            return product && (denomination === 'all' || card.dataset.kitDenomination === denomination) && (value === 'all' || product.stacks === Number(value));
          });
          button.setAttribute('aria-pressed', String(value === stackCount));
        });
        jumps.forEach((button, position) => {
          const card = visibleCards().find(card => card.dataset.kitId === baseCards[position].dataset.kitId);
          const product = card && selectedProduct(card);
          button.querySelector('[data-jump-price]').textContent = product ? product.price : '—';
        });
        const byPrice = matchingProducts.slice().sort((a, b) => a.amount - b.amount);
        if (byPrice.length && byPrice[0].amount === byPrice[byPrice.length - 1].amount) {
          root.querySelector('.pmks__range').textContent = format(byPrice.length === 1 ? data.labels.single_result : data.labels.multiple_results, { count: byPrice.length }) + ' · ' + byPrice[0].price;
        } else if (byPrice.length) {
          root.querySelector('.pmks__range').textContent = format(data.labels.range, { count: byPrice.length, minimum: byPrice[0].price, maximum: byPrice[byPrice.length - 1].price });
        }
        root.querySelector('[data-selection-status]').textContent = format(data.labels.status, { denomination: data.labels.descriptions[denomination], count: matchingProducts.length });
        root.dataset.selectedDenomination = denomination;
        root.dataset.selectedStackCount = stackCount;
        gallery.scrollTo({ left: 0, behavior: 'instant' });
        index = 0;
        update();
      }
      previous.addEventListener('click', () => move(index - 1), { signal });
      next.addEventListener('click', () => move(index + 1), { signal });
      jumps.forEach((button, position) => {
        button.disabled = false;
        button.addEventListener('click', () => {
          const activeIndex = visibleCards().findIndex(card => card.dataset.kitId === baseCards[position].dataset.kitId);
          if (activeIndex >= 0) move(activeIndex);
        }, { signal });
      });
      gallery.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(update);
      }, { passive: true, signal });
      choices.forEach(button => button.addEventListener('click', () => {
        if (button.disabled) return;
        denomination = button.dataset.denomination;
        renderSelection();
      }, { signal }));
      stackChoices.forEach(button => button.addEventListener('click', () => {
        if (button.disabled) return;
        stackCount = button.dataset.stackCount;
        renderSelection();
      }, { signal }));
      const observer = new ResizeObserver(update);
      observer.observe(gallery);
      root.dataset.enhanced = 'true';
      instances.set(root, () => { controller.abort(); observer.disconnect(); });
      renderSelection();
    }
    const scan = scope => {
      if (scope.matches?.('[data-pm-kit-showcase]')) initialize(scope);
      scope.querySelectorAll('[data-pm-kit-showcase]').forEach(initialize);
    };
    scan(document);
    document.addEventListener('shopify:section:load', event => scan(event.target));
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.matches?.('[data-pm-kit-showcase]')) instances.get(event.target)?.();
      event.target.querySelectorAll('[data-pm-kit-showcase]').forEach(root => instances.get(root)?.());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-series-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const format = (text, values) => text.replace(/\[(\w+)\]/g, (_, key) => values[key] ?? '');
    const initialize = scope => {
      const roots = scope.matches?.('[data-pm-series-showcase]') ? [scope] : scope.querySelectorAll('[data-pm-series-showcase]');
      roots.forEach(root => {
        if (root.dataset.seriesInitialized) return;
        root.dataset.seriesInitialized = 'true';
        const controller = new AbortController();
        const signal = controller.signal;
        const tabs = Array.from(root.querySelectorAll('[data-series-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-series-panel]'));
        const rail = root.querySelector('.pms__series-scroll');
        const update = panel => {
          if (panel.hidden) return;
          const gallery = panel.querySelector('.pms__gallery');
          const cards = Array.from(gallery.children);
          if (!cards.length) return;
          const gap = parseFloat(getComputedStyle(gallery).columnGap) || 0;
          const step = cards[0].getBoundingClientRect().width + gap;
          const visible = parseInt(getComputedStyle(root).getPropertyValue('--pms-visible'), 10) || 3;
          const index = Math.max(0, Math.min(cards.length - 1, Math.round(gallery.scrollLeft / step)));
          panel.querySelector('[data-series-counter]').textContent = format(visible === 1 ? root.dataset.single : root.dataset.range, { first: index + 1, last: Math.min(cards.length, index + visible), total: cards.length });
          panel.querySelector('[data-series-direction="-1"]').disabled = gallery.scrollLeft <= 2;
          panel.querySelector('[data-series-direction="1"]').disabled = gallery.scrollLeft >= gallery.scrollWidth - gallery.clientWidth - 2;
        };
        const select = (id, focus = false) => {
          const selected = tabs.find(tab => tab.dataset.seriesTab === id);
          if (!selected) return;
          tabs.forEach(tab => {
            const active = tab === selected;
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });
          panels.forEach(panel => {
            panel.hidden = panel.dataset.seriesPanel !== id;
            if (!panel.hidden) {
              panel.querySelector('.pms__gallery').scrollLeft = 0;
              update(panel);
              root.querySelector('[data-series-status]').textContent = format(root.dataset.status, { series: panel.dataset.seriesTitle });
            }
          });
          const offset = selected.offsetLeft - rail.offsetLeft - (rail.clientWidth - selected.offsetWidth) / 2;
          rail.scrollTo({ left: Math.max(0, offset), behavior: reducedMotion() ? 'instant' : 'smooth' });
          if (focus) selected.focus({ preventScroll: true });
        };
        tabs.forEach((tab, index) => {
          tab.tabIndex = index === 0 ? 0 : -1;
          tab.addEventListener('click', event => { event.preventDefault(); select(tab.dataset.seriesTab); }, { signal });
          tab.addEventListener('keydown', event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            select(tabs[next].dataset.seriesTab, true);
          }, { signal });
        });
        panels.forEach(panel => {
          const gallery = panel.querySelector('.pms__gallery');
          let scheduled = false;
          gallery.addEventListener('scroll', () => {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(() => { scheduled = false; update(panel); });
          }, { passive: true, signal });
          panel.querySelectorAll('[data-series-direction]').forEach(button => button.addEventListener('click', () => {
            const card = gallery.firstElementChild;
            if (!card) return;
            const gap = parseFloat(getComputedStyle(gallery).columnGap) || 0;
            gallery.scrollBy({ left: (card.getBoundingClientRect().width + gap) * Number(button.dataset.seriesDirection), behavior: reducedMotion() ? 'instant' : 'smooth' });
          }, { signal }));
          update(panel);
        });
        const observer = new ResizeObserver(() => panels.forEach(update));
        observer.observe(root);
        root.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-series-panel]');
          if (panel) select(panel.dataset.seriesPanel);
        }, { signal });
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(root)) { observer.disconnect(); controller.abort(); }
        }, { signal });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    else initialize(document);
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
